/* eslint-disable react/prop-types */
import React, {
  useState, useEffect, useContext, useRef,
} from 'react'
import PropTypes from 'prop-types'
import _ from 'lodash'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import Popup from 'reactjs-popup'
import { useNavigate, useParams } from 'react-router-dom'
import ReactGA from 'react-ga4'

import Table from '@components/table'
import InfoBox from '@components/infoBox'
import BeneficiaryCheckBox from '@components/table/beneficiaryCheckBox'
import Loading from '@components/loading'
import CollectionsHistoryModal from '@components/modal/collectionsHistoryModal'
import PrimaryButton from '@components/inputs/button/primaryButton'
import TermsModal from '@components/modal/termsModal'
import { WindowContext } from '@components/windowContextProvider'
import {
  uploadProfileImage as uploadProfileImageAction,
  updateProfileImage as updateProfileImageAction
} from '@actions/profileImage'

import {
  clearBeneficiary as clearBeneficiaryAction,
  getReportToInsurance as getReportToInsuranceAction,
} from '@actions/beneficiary'
import {
  listCollections as listCollectionsAction,
  clearCollections as clearCollectionsAction,
} from '@actions/collection'

import { cpfShowMask } from '@util/stringUtil'
import {
  getRisks,
  getRiskClassification,
  colorByRisks,
} from '@util/classificationUtil'
import {
  getIfIsDiabetic,
  getIfIsDyslipidemic,
  getIfIsHypertensive,
  getImc,
} from '@util/equationsUtil'
import {
  DiabeticEnum,
  DislipidemicEnum,
  HypertensionEnum,
  ObesityEnum,
  HealthyEnum,
  NotCollectedEnum,
} from '@util/risksEnum'

import colors from '@settings/styleSettings'
import {
  Text,
  InfoBoxContainer,
  ToolTipCard,
  HeaderContainer,
  BarChartIcon,
  CheckCircleOutlineIcon,
  NameAligner,
  TextPopUp,
  StyledPopup,
  MoreHorizIcon,
  ActionsGrid, // grid (pirâmide invertida)
  ActionsCell, // wrapper para alinhar e dar respiro
} from './styles'

function iconFilterFields(orderBy) {
  function statusArrowDesc() {
    if (orderBy === 'desc') return colors.primary
    return colors.background
  }
  function statusArrowAsc() {
    if (orderBy === 'asc') return colors.primary
    return colors.background
  }
  return (
    <svg width={18} xmlns="http://www.w3.org/2000/svg" viewBox="1 -1 16 16">
      <svg height="17" viewBox="3 0 7 16">
        <path
          fill={!orderBy ? colors.strongGray : statusArrowDesc()}
          d="M.155 6.138a.477.477 0 01.36-.15.514.514 0 01.361.16l2.181 2.18V.5c0-.141.048-.26.144-.356A.483.483 0 013.556 0c.142 0 .26.048.356.143A.483.483 0 014.055.5v7.83L6.253 6.13a.473.473 0 01.348-.148.49.49 0 01.357.155.49.49 0 01.155.355.49.49 0 01-.155.356l-2.98 2.98a.55.55 0 01-.423.171.552.552 0 01-.42-.17L.138 6.833A.452.452 0 010 6.495a.49.49 0 01.155-.357z"
        />
      </svg>
      <svg height="17" x="5" fill="none" viewBox="2.5 0 7 16">
        <path
          fill={!orderBy ? colors.strongGray : statusArrowAsc()}
          d="M7.394 3.862a.477.477 0 01-.361.15.514.514 0 01-.36-.16L4.49 1.672V9.5c0 .141-.047.26-.143.356a.483.483 0 01-.356.143.483.483 0 01-.355-.143.483.483 0 01-.144-.356V1.67L1.296 3.87a.473.473 0 01-.349.148.49.49 0 01-.356-.155.49.49 0 01-.155-.355.49.49 0 01.155-.356L3.57.17A.55.55 0 013.993 0a.552.552 0 01.42.17l2.998 2.997c.092.09.138.203.138.338a.49.49 0 01-.155.357z"
        />
      </svg>
    </svg>
  )
}

const BeneficiaryList = ({
  beneficiaries,
  selectedBeneficiaries,
  onClickReportRelatory,
  filterState,
  setFilterState,
  listCollections,
  collectionList,
  clearCollections,
  clearBeneficiary,
  onSelectedBeneficiariesChange,
  uploadProfileImage,
  updateProfileImage,
}) => {
  const navigate = useNavigate()
  const { insurance } = useParams()

  const { clientWidth } = useContext(WindowContext)

  const [loadingTerms, setLoadingTerms] = useState([])
  const [loadingCollections, setLoadingCollections] = useState([])
  const [loadingHistory, setLoadingHistory] = useState(false)
  const [openCollectionHistoryModal, setOpenCollectionHistoryModal] = useState(false)
  const [selectedBeneficiary, setSelectedBeneficiary] = useState(null)
  const [collections, setCollections] = useState([])
  const [openTermsModal, setOpenTermsModal] = useState(false)
  const [oneCollection, setOneCollection] = useState(false)

  const inputRefs = useRef({})
  const [uploadingId, setUploadingId] = useState(null)

  const onClickUpload = (ben) => inputRefs.current[ben.id]?.click()

  const onFileChange = (e, ben) => {
    const file = e.target.files?.[0]
    if (!file) return
    setUploadingId(ben.id)
    const send = ben.profileImageBase64 ? updateProfileImage : uploadProfileImage
    send(ben.id, file, () => setUploadingId(null))
  }

  useEffect(() => {
    if (beneficiaries) {
      setLoadingTerms(Array(beneficiaries?.length))
      setLoadingCollections(Array(beneficiaries?.length))
    }
  }, [beneficiaries])

  useEffect(() => {
    if ((collectionList && collectionList.length === 1) && oneCollection) {
      clearBeneficiary()
      clearCollections()
      navigate(`/${insurance}/beneficiario/report/${selectedBeneficiary.id}`)
    }
    setCollections(collectionList)
    setLoadingHistory(false)
  }, [collectionList])

  useEffect(() => {
    if (selectedBeneficiary) {
      listCollections({ beneficiaryId: selectedBeneficiary.id })
    }
  }, [selectedBeneficiary])

  useEffect(() => {
    onSelectedBeneficiariesChange(selectedBeneficiaries)
  }, [selectedBeneficiaries])

  const removeTableItemOnWidth = (arr) => {
    if (clientWidth <= 900) arr.splice(1, 1)
    if (clientWidth <= 700) arr.splice(1, 1)
    if (clientWidth <= 420) arr.splice(2, 1)
  }

  const buttonOptionBreak = clientWidth < 545

  const setOrderByName = () => {
    if (filterState.orderByName === 'desc') {
      setFilterState({ ...filterState, orderByName: 'asc' })
    } else {
      setFilterState({ ...filterState, orderByName: 'desc' })
    }
  }

  const setOrderByRisk = () => {
    if (!filterState.orderByRisk) {
      setFilterState({ ...filterState, orderByRisk: 'desc' })
    } else if (filterState.orderByRisk === 'desc') {
      setFilterState({ ...filterState, orderByRisk: 'asc' })
    } else {
      setFilterState({ ...filterState, orderByRisk: null })
    }
  }

  const setOrderByCollectionDate = () => {
    if (!filterState.orderByCollectionDate) {
      setFilterState({ ...filterState, orderByCollectionDate: 'desc' })
    } else if (filterState.orderByCollectionDate === 'desc') {
      setFilterState({ ...filterState, orderByCollectionDate: 'asc' })
    } else {
      setFilterState({ ...filterState, orderByCollectionDate: null })
    }
  }

  const onSelectBeneficiary = (addSelected, beneficiary) => {
    if (addSelected) {
      onSelectedBeneficiariesChange([...selectedBeneficiaries, beneficiary])
    } else {
      onSelectedBeneficiariesChange(
        _.filter(selectedBeneficiaries, ({ id }) => id !== beneficiary.id)
      )
    }
  }

  const setBeneficiaryLoadingTrue = (idx) => {
    const aux = loadingTerms
    aux[idx] = true
    setLoadingTerms(aux)
  }

  const goToConsentForm = (beneficiary, idx) => {
    setBeneficiaryLoadingTrue(idx)
    setSelectedBeneficiary(beneficiary)
    setOpenTermsModal(true)
  }

  const handleOpenCollectionHistoryModal = (beneficiary, idx) => {
    const aux = loadingCollections
    aux[idx] = true
    setLoadingCollections(aux)
    setCollections([])
    setSelectedBeneficiary(beneficiary)
    setLoadingHistory(true)
    setOpenCollectionHistoryModal(true)
  }

  const handleCloseModal = () => {
    loadingCollections.fill(false)
    setSelectedBeneficiary(null)
    setOpenCollectionHistoryModal(false)
    setOneCollection(false)
  }

  const handleCloseTermsModal = () => {
    loadingTerms.fill(false)
    setSelectedBeneficiary(null)
    setOpenTermsModal(false)
  }

  const toBr = (date) => {
    const pad = (n) => n.toString().padStart(2, '0')
    return (
      `${pad(date.getDate())}/${pad(date.getMonth() + 1)}/${date.getFullYear()} `
      + `${pad(date.getHours())}:${pad(date.getMinutes())}`
    )
  }

  const formatDateTime = (str) => {
    if (!str) return 'Não coletado'

    const m = str.match(
      /^(\d{2})\/(\d{2})\/(\d{4})[ T](\d{2}):(\d{2})(?::(\d{2}))?$/
    )
    if (m) {
      const [, dd, MM, yyyy, hh, mm, ss = '0'] = m
      const d = new Date(+yyyy, +MM - 1, +dd, +hh, +mm, +ss)
      if (isValid(d)) return toBr(d)
    }

    const dNative = new Date(str)
    if (isValid(dNative)) return toBr(dNative)

    return ' '
  }

  function isValid(date) {
    return date instanceof Date && !Number.isNaN(date.getTime())
  }

  const dataHeads = [
    <NameAligner>
      <HeaderContainer onClick={setOrderByName}>
        {iconFilterFields(filterState.orderByName)}
        NOME
      </HeaderContainer>
    </NameAligner>,
    'CPF',
    'CARTEIRINHA',
    <HeaderContainer onClick={setOrderByRisk}>
      {iconFilterFields(filterState.orderByRisk)}
      RISCO
    </HeaderContainer>,
    <HeaderContainer onClick={setOrderByCollectionDate}>
      {iconFilterFields(filterState.orderByCollectionDate)}
      DATA DE COLETA
    </HeaderContainer>,
    'COMORBIDADES',
    'AÇÕES',
  ]

  removeTableItemOnWidth(dataHeads)

  const data = _.map(beneficiaries, (beneficiary, idx) => {
    const {
      id, name, cpf, hasAssign, insuranceNumber, profileImageBase64,
    } = beneficiary
    const lastCollection = beneficiary.lastGeneralCollection || {}
    const {
      systBloodPressure,
      diastBloodPressure,
      glucose,
      totalCholesterol,
      hdlCholesterol,
      triglycerides,
      ldlCholesterol,
      weight,
      height,
      hasDiabetes,
      hasSystemicArterialHypertension,
      collectedAt
    } = lastCollection

    const hypertensiveRisk = getIfIsHypertensive(
      systBloodPressure,
      diastBloodPressure
    )
    const diabeticRisk = getIfIsDiabetic(glucose)
    const dyslipidemicRisk = getIfIsDyslipidemic(
      totalCholesterol,
      hdlCholesterol,
      triglycerides,
      ldlCholesterol
    )
    const imcRisk = getImc(weight, height)

    const risks = getRisks(
      hypertensiveRisk,
      diabeticRisk,
      dyslipidemicRisk,
      imcRisk
    )

    let risksValue
    if (risks === -1) {
      risksValue = -2
    } else {
      risksValue = risks.length
    }

    const risksLength = risksValue

    const comorbidities = []
    if (hypertensiveRisk || hasSystemicArterialHypertension) {
      comorbidities.push(
        getInfoBoxByClassification(risksLength, HypertensionEnum.label)
      )
    }
    if (diabeticRisk || hasDiabetes) {
      comorbidities.push(
        getInfoBoxByClassification(risksLength, DiabeticEnum.label)
      )
    }
    if (dyslipidemicRisk) {
      comorbidities.push(
        getInfoBoxByClassification(risksLength, DislipidemicEnum.label)
      )
    }
    if (imcRisk > 25) {
      comorbidities.push(
        getInfoBoxByClassification(risksLength, ObesityEnum.label)
      )
    }

    const getComorbidities = () => {
      if (!Object.keys(lastCollection).length) {
        return getInfoBoxByClassification(-1, NotCollectedEnum.label)
      }
      if (comorbidities.length === 0) {
        return getInfoBoxByClassification(risksLength, HealthyEnum.label)
      }
      if (comorbidities.length > 1) {
        return (
          <InfoBoxContainer>
            {_.times(1, (i) => comorbidities[i])}
            {getInfoBoxByClassification(null, '...', comorbidities.slice(1))}
          </InfoBoxContainer>
        )
      }
      return <InfoBoxContainer>{_.map(comorbidities)}</InfoBoxContainer>
    }

    // 🔻 Pirâmide invertida (em grid) + wrapper anti-overflow
    const actions = (
      <ActionsCell>
        <ActionsGrid>
          {/* 📊 Relatório (topo-esquerda) */}
          <StyledPopup
            trigger={() => (
              <span className="btn btn-report">
                <PrimaryButton
                  size={40}
                  onClick={() => {
                    setOneCollection(true)
                    handleOpenCollectionHistoryModal(beneficiary, idx)
                    ReactGA.event({
                      category: 'Acessar relatório de saúde',
                      action: 'Clique em relatório de saúde',
                      label: 'Botão de acessar relatório de saúde ',
                    })
                  }}
                  // Habilita o relatório assim que existir alguma coleta,
                  // mesmo que exames laboratoriais específicos não tenham sido enviados.
                  disabled={!Object.keys(lastCollection).length}
                >
                  {loadingCollections[idx] ? (
                    <Loading />
                  ) : (
                    <BarChartIcon className="material-icons-outlined">bar_chart</BarChartIcon>
                  )}
                </PrimaryButton>
              </span>
            )}
            on={['hover', 'focus', 'click']}
            position="top right"
            closeOnDocumentClick
          >
            <TextPopUp>Relatório de saúde</TextPopUp>
          </StyledPopup>

          {/* ✅ Termo (topo-direita) */}
          <StyledPopup
            trigger={() => (
              <span className="btn btn-consent">
                <PrimaryButton
                  onClick={() => goToConsentForm(beneficiary, idx)}
                  size={40}
                  disabled={!hasAssign}
                >
                  {loadingTerms[idx] ? (
                    <Loading />
                  ) : (
                    <CheckCircleOutlineIcon className="material-icons-outlined">check_circle</CheckCircleOutlineIcon>
                  )}
                </PrimaryButton>
              </span>
            )}
            on={['hover', 'focus', 'click']}
            position="top right"
            closeOnDocumentClick
          >
            <TextPopUp>{!hasAssign ? 'Não assinado' : 'Termo de consentimento'}</TextPopUp>
          </StyledPopup>

          {/* 📷 Câmera (linha de baixo central, ocupa 2 colunas) */}
          <span className="btn btn-camera">
            <input
              type="file"
              accept="image/*"
              style={{ display: 'none' }}
              ref={(el) => { if (el) inputRefs.current[id] = el }}
              onChange={(e) => onFileChange(e, beneficiary)}
            />
            <PrimaryButton
              onClick={() => onClickUpload(beneficiary)}
              size={40}
              disabled={uploadingId === id}
              title={profileImageBase64 ? 'Atualizar foto' : 'Enviar foto'}
            >
              {uploadingId === id ? <Loading /> : (
                <span className="material-icons-outlined">photo_camera</span>
              )}
            </PrimaryButton>
          </span>
        </ActionsGrid>
      </ActionsCell>
    )

    const row = [
      <BeneficiaryCheckBox
        name={name}
        imageBase64={profileImageBase64}
        isChecked={_.some(selectedBeneficiaries, ({ id: bId }) => bId === id)}
        onChange={(e) => onSelectBeneficiary(e, beneficiary)}
      />,

      <Text>{cpfShowMask(cpf)}</Text>,

      <Text>{insuranceNumber}</Text>,

      Object.keys(lastCollection).length
        ? getInfoBoxByClassification(
          risksLength,
          getRiskClassification(risksLength)
        )
        : getInfoBoxByClassification(-1, getRiskClassification(-1)),

      <Text>{formatDateTime(collectedAt)}</Text>,

      getComorbidities(),

      // AÇÕES (em grid pirâmide). Mantém versão colapsada em telas pequenas.
      buttonOptionBreak ? (
        <Popup
          trigger={() => (
            <div>
              <MoreHorizIcon className="material-icons-outlined">more_horiz</MoreHorizIcon>
            </div>
          )}
          on={['click']}
          position="top right"
          closeOnDocumentClick
        >
          <ToolTipCard>{actions}</ToolTipCard>
        </Popup>
      ) : (
        actions
      ),
    ]

    removeTableItemOnWidth(row)
    return row
  })

  function getInfoBoxByClassification(
    riskLevel,
    label,
    comorbiditiesToTooltip
  ) {
    const color = colorByRisks(riskLevel)
    return comorbiditiesToTooltip ? (
      <Popup
        trigger={() => (
          <div>
            <InfoBox color={color} label={label} key={label} />
          </div>
        )}
        on={['hover', 'focus']}
        position="top right"
        closeOnDocumentClick
      >
        <ToolTipCard>{_.map(comorbiditiesToTooltip)}</ToolTipCard>
      </Popup>
    ) : (
      <InfoBox color={color} label={label} key={label} />
    )
  }

  return (
    <>
      <Table
        dataHeads={dataHeads}
        data={data}
        dataWidth={['25%', '15%', '15%', '12%', '12%', '13%', '140px']} // 👈 fixa AÇÕES
      />
      {selectedBeneficiary && collections?.length > 1 && (
        <CollectionsHistoryModal
          collections={collections}
          isOpen={openCollectionHistoryModal}
          setClose={() => handleCloseModal()}
          beneficiaryId={selectedBeneficiary.id}
          onClickReportRelatory={onClickReportRelatory}
          isLoading={loadingHistory}
        />
      )}
      {selectedBeneficiary && (
        <TermsModal
          isOpen={openTermsModal}
          setClose={() => handleCloseTermsModal()}
          beneficiary={selectedBeneficiary}
        />
      )}
    </>
  )
}

BeneficiaryList.propTypes = {
  onSelectedBeneficiariesChange: PropTypes.func.isRequired,
  selectedBeneficiaries: PropTypes.arrayOf(PropTypes.object).isRequired,
  beneficiaries: PropTypes.arrayOf(
    PropTypes.shape({
      name: PropTypes.string,
      age: PropTypes.number,
      insuranceNumber: PropTypes.string,
      cpf: PropTypes.string,
      sex: PropTypes.string,
      birthdate: PropTypes.string,
      lastCollection: PropTypes.shape({
        collectedAt: PropTypes.string,
        height: PropTypes.number,
        weight: PropTypes.number,
        abdominalCircumference: PropTypes.number,
        waistCircumference: PropTypes.number,
        hipCircumference: PropTypes.number,
        fat: PropTypes.number,
        visceralFat: PropTypes.number,
        leanMass: PropTypes.number,
        calories: PropTypes.number,
        triglycerides: PropTypes.number,
        glucose: PropTypes.number,
        hdlCholesterol: PropTypes.number,
        ldlCholesterol: PropTypes.number,
        systBloodPressure: PropTypes.number,
        diastBloodPressure: PropTypes.number,
        totalCholesterol: PropTypes.number,
        notHdl: PropTypes.number,
        hasSystemicArterialHypertension: PropTypes.bool,
        hasDiabetes: PropTypes.bool,
      }),
    })
  ),
  filterState: PropTypes.shape({
    orderByName: PropTypes.string,
    orderByRisk: PropTypes.string,
    orderByCollectionDate: PropTypes.string,
  }),
  setFilterState: PropTypes.func.isRequired,
  onClickReportRelatory: PropTypes.func,
  reportData: PropTypes.shape({
    name: PropTypes.string,
    age: PropTypes.number,
    insuranceNumber: PropTypes.string,
    cpf: PropTypes.string,
    sex: PropTypes.string,
    birthdate: PropTypes.string,
    lastCollection: PropTypes.shape({
      collectedAt: PropTypes.string,
      height: PropTypes.number,
      weight: PropTypes.number,
      abdominalCircumference: PropTypes.number,
      waistCircumference: PropTypes.number,
      hipCircumference: PropTypes.number,
      fat: PropTypes.number,
      visceralFat: PropTypes.number,
      leanMass: PropTypes.number,
      calories: PropTypes.number,
      triglycerides: PropTypes.number,
      glucose: PropTypes.number,
      hdlCholesterol: PropTypes.number,
      ldlCholesterol: PropTypes.number,
      systBloodPressure: PropTypes.number,
      diastBloodPressure: PropTypes.number,
      totalCholesterol: PropTypes.number,
      notHdl: PropTypes.number,
      hasSystemicArterialHypertension: PropTypes.bool,
      hasDiabetes: PropTypes.bool,
    }),
  }),
  listCollections: PropTypes.func.isRequired,
  collectionList: PropTypes.arrayOf(PropTypes.object),
  clearCollections: PropTypes.func.isRequired,
  clearBeneficiary: PropTypes.func.isRequired,

  uploadProfileImage: PropTypes.func.isRequired,
  updateProfileImage: PropTypes.func.isRequired,
}

BeneficiaryList.defaultProps = {
  beneficiaries: [],
  filterState: {},
  reportData: null,
  collectionList: [],
  onClickReportRelatory: null
}

const mapStateToProps = ({ collection }) => ({
  collectionList: collection.list,
})

const mapDispatchToProps = (dispatch) => bindActionCreators(
  {
    getReportToInsurance: getReportToInsuranceAction,
    listCollections: listCollectionsAction,
    clearCollections: clearCollectionsAction,
    clearBeneficiary: clearBeneficiaryAction,
    uploadProfileImage: uploadProfileImageAction,
    updateProfileImage: updateProfileImageAction,
  },
  dispatch
)

export default connect(mapStateToProps, mapDispatchToProps)(BeneficiaryList)
